module.exports = __webpack_public_path__ + "static/media/ccFront.0fc26689.png";